var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-footer text-center mt-10"},[_c('p',[_vm._v("© "+_vm._s(this.appYear())+" "+_vm._s(this.appName())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }